import { init as configInit } from '@bounded-sh/core';
export async function init(newConfig) {
    await configInit(Object.assign(Object.assign({}, newConfig), { authProvider: null, isServer: true, skipBackendInit: true }));
}
//# sourceMappingURL=global.js.map